module.exports = __webpack_public_path__ + "img/cloud-bolt-moon.5e628f7e.svg";